// calculadora-proteina.js
function initCalculadora(containerId, popupId) {
  const container = document.getElementById(containerId);
  if (!container) return;

  const btnCalc = container.querySelector(".btn-calculate");
  const resultadoBox = container.querySelector("[data-role='resultado']");
  const resultadoWrapper = container.querySelector(".resultado-wrapper");

  let selectedActividad = null;
  let selectedMG = null;

  const ProductosRecomendados = document.querySelector(
  "#shopify-section-template--24523081973794__home_product_carousel_DgkPE7"
);

if (ProductosRecomendados) {
  ProductosRecomendados.classList.add("product-carousel-hidden"); // ocultar al inicio
}


  // ---------------------------
  // Helpers
  // ---------------------------
  function getBaseRange(peso, genero, edad) {
    if (edad >= 18 && edad <= 30) {
      if (genero === "M") return peso * 1.2;
      if (genero === "F") return peso * 1.0;
    }
    if (edad >= 31 && edad <= 50) {
      if (genero === "M") return peso * 1.2;
      if (genero === "F") return peso * 1.0;
    }
    if (edad >= 51 && edad <= 60) {
      return peso * 1.7;
    }
    if (edad > 60) {
      return peso * 2.0;
    }
    return peso * 1.0;
  }

  function getActivityFactor(actividad) {
    switch (actividad) {
      case "sedentario":
        return 0.9;
      case "medio":
        return 1.25;
      case "alto":
        return 1.62;
      case "atleta":
        return 2.4;
    }
  }

  function calculateProtein(peso, genero, edad, actividad) {
  let base = getBaseRange(peso, genero, edad);
  let factor = getActivityFactor(actividad);
  let total = Math.round(base * factor);
  return [total, total];
}


  function clearErrors() {
    container.querySelectorAll(".error").forEach(e => e.style.display = "none");
  }

  function showError(field) {
    const el = container.querySelector(`[data-error='${field}']`);
    if (el) el.style.display = "block";
  }

  // ---------------------------
  // Selección actividad
  // ---------------------------
  container.querySelectorAll(".actividad-option").forEach(opt => {
    opt.addEventListener("click", () => {
      container.querySelectorAll(".actividad-option")
        .forEach(o => o.classList.remove("selected"));
      opt.classList.add("selected");
      selectedActividad = opt.getAttribute("data-value");
    });
  });

  // ---------------------------
  // Selección músculo/grasa
  // ---------------------------
  container.querySelectorAll(".musculograsa-block").forEach(opt => {
    opt.addEventListener("click", () => {
      container.querySelectorAll(".musculograsa-block")
        .forEach(o => o.classList.remove("selected"));
      opt.classList.add("selected");
      selectedMG = opt.getAttribute("data-value");
    });
  });

  // ---------------------------
  // Calcular
  // ---------------------------
  btnCalc.addEventListener("click", () => {
    clearErrors();

    // inputs con id dinámico
    const sectionSuffix = containerId.replace("calculadora-proteina-", "");
    const pesoEl   = document.getElementById(`peso-${sectionSuffix}`);
    const alturaEl = document.getElementById(`altura-${sectionSuffix}`);
    const edadEl   = document.getElementById(`edad-${sectionSuffix}`);
    const generoEl = document.getElementById(`genero-${sectionSuffix}`);

    if (!pesoEl || !alturaEl || !edadEl || !generoEl) {
      console.error("❌ No se encontraron los inputs dentro del contenedor", containerId);
      return;
    }

    const peso   = Number(pesoEl.value.trim());
    const altura = Number(alturaEl.value.trim());
    const edad   = Number(edadEl.value.trim());
    const genero = generoEl.value;

    let valid = true;

    if (isNaN(peso) || peso <= 0) {
      showError("peso");
      valid = false;
    }
    if (isNaN(altura) || altura <= 0) {
      showError("altura");
      valid = false;
    }
    if (isNaN(edad) || edad < 18) {
      showError("edad");
      valid = false;
    }
    if (!genero) {
      showError("genero");
      valid = false;
    }
    if (!selectedActividad) {
      alert("Selecciona tu nivel de actividad.");
      valid = false;
    }
    if (!selectedMG) {
      alert("Selecciona si tu peso es más músculo o grasa.");
      valid = false;
    }
    if (!valid) return;

    // Calcular proteína
    let [minProt, maxProt] = calculateProtein(peso, genero, edad, selectedActividad);

    // Ajuste músculo/grasa
    let ajuste = selectedMG === "musculo" ? 1.1 : 0.9;
    const minFinal = Math.round(minProt * ajuste);
    const maxFinal = Math.round(maxProt * ajuste);

    //resultadoBox.textContent = `${minFinal}g - ${maxFinal}g de proteína al día`;
    //resultadoWrapper.style.display = "block";

    const resultadoTexto = `
  Tu recomendación personalizada es: <strong>${minFinal} gramos</strong> de proteína al día 🔥<br>
  <span class="nota-proteina">
    ⚠️ Recuerda: 100 g de pollo, carne o pescado no son 100 g de proteína.<br>
    En promedio, aportan solo 18–25 g de proteína por cada 100 g de alimento 😲
  </span>`;


    resultadoBox.setAttribute("data-pendiente", resultadoTexto);

    //Guardar en el local Storage
    localStorage.setItem("resultadoProteina", resultadoTexto);

    // Mostrar popup o directamente el resultado si ya se registró antes
const popup = document.getElementById(popupId);
const yaTieneRegistro = localStorage.getItem("yaRegistroProteina");

if (yaTieneRegistro) {
    // Mostrar resultado directamente
    resultadoBox.innerHTML = resultadoTexto;
    resultadoWrapper.style.display = "block";

    const ProductosRecomendados = document.querySelector("#shopify-section-template--24523081973794__home_product_carousel_DgkPE7");
    if (ProductosRecomendados) {
      ProductosRecomendados.classList.remove("product-carousel-hidden");
    }

    // Scroll suave al resultado
    setTimeout(() => {
      const offset = resultadoWrapper.getBoundingClientRect().top + window.scrollY - 150;
      window.scrollTo({ top: offset, behavior: "smooth" });
    }, 500);
  } else {
    // Solo si no se ha registrado, mostrar el popup
    if (popup) popup.style.display = "flex";
  }

  });

  // ---------------------------
  // Popup newsletter
  // ---------------------------
  const popup = document.getElementById(popupId);
  if (popup) {
    const closeBtn = popup.querySelector(".close");
    if (closeBtn) {
      closeBtn.addEventListener("click", () => popup.style.display = "none");
    }

    const formNewsletter = popup.querySelector(".newsletter-form");
    const successMsg = popup.querySelector(".newsletter-success");

    if (formNewsletter) {
      formNewsletter.addEventListener("submit", (e) => {
  e.preventDefault();
  formNewsletter.style.display = "none";
  if (successMsg) successMsg.style.display = "block";

  //Mostramos el resultado
  const pendiente = resultadoBox.getAttribute("data-pendiente");
  if (pendiente) {
    resultadoBox.innerHTML = pendiente;
    resultadoWrapper.style.display = "block";
    resultadoBox.removeAttribute("data-pendiente");
  }

  // 🔒 Guardar que ya se registró
  localStorage.setItem("yaRegistroProteina", "true");

  // Mostrar productos
      const ProductosRecomendados = document.querySelector("#shopify-section-template--24523081973794__home_product_carousel_DgkPE7");
      if (ProductosRecomendados) {
        ProductosRecomendados.classList.remove("product-carousel-hidden");
      }

  setTimeout(() => popup.style.display = "none", 1500);
});

    }
  }

// Restaurar resultado si viene de localStorage
const yaTieneRegistro = localStorage.getItem("yaRegistroProteina");
const resultadoGuardado = localStorage.getItem("resultadoProteina");
if (yaTieneRegistro && resultadoGuardado) {
  resultadoBox.innerHTML = resultadoGuardado;
  resultadoWrapper.style.display = "block";

  const ProductosRecomendados = document.querySelector("#shopify-section-template--24523081973794__home_product_carousel_DgkPE7");
  if (ProductosRecomendados) {
    ProductosRecomendados.classList.remove("product-carousel-hidden");
  }

  // ✅ Hacer scroll automático al resultado
  setTimeout(() => {
    const offset = resultadoWrapper.getBoundingClientRect().top + window.scrollY - 150; 
    window.scrollTo({ top: offset, behavior: "smooth" });
  }, 500); // pequeño delay para que cargue bien la vista

  // ✅ Limpia después de mostrar
  localStorage.removeItem("resultadoProteina");
}



}
